module.exports = __webpack_public_path__ + "img/ic_arrow_point.f5094703.svg";